import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Routes } from 'routing';

import AccountLanding from './AccountLanding';
import SetPageHeaderRightContent from 'components/Portals/SetPageHeaderRightContent';

import General from './General';
import Stores from './Stores';
import Billing from './Billing';
import Users from './Users';
import Payments from './Payments';
import Integrations from './Integrations';
import Accounting from './Accounting';
import Reports from './Reports';
import Languages from './Languages';
import Profile from './Profile';
import Notifications from './Notifications';
import Taxation from './Taxation';
import Localization from './Localization';
import Domains from './Domains';
import Marketing from './Marketing';
import Terms from './Terms';
import { useHasFeature } from 'hooks/useHasFeature';

const Account = () => {
	const { hasFeature } = useHasFeature();

	return (
		<>
			{/** Hide the online store link for all account pages by default */}
			<SetPageHeaderRightContent priority={1} />
			<Switch>
				<Route exact path={Routes.ACCOUNT} component={AccountLanding} />
				<Route path={Routes.ACCOUNT_PROFILE} component={Profile} />
				{hasFeature('LEGAL_SETTINGS') && <Route path={Routes.ACCOUNT_TERMS} component={Terms} />}
				{/**
				 * React-router (v5) does not properly support higher-order components within a Switch component. Switch components will stop at
				 * the first child that matches the @path and even if that component returns null due to some feature checks, it does not continue further
				 * which messes up any redirect/fallthrough rules lower below.
				 *
				 * This is why we need to define these feature routes like below, without using a higher order component.
				 */}
				{hasFeature(['LEGAL_SETTINGS', 'BRANDING'], { filteringType: 'SOME' }) && (
					<Route path={Routes.ACCOUNT_GENERAL} component={General} />
				)}

				{hasFeature('STORES') && <Route path={Routes.ACCOUNT_STORES} component={Stores} />}

				{hasFeature('PLAN_BILLING') && <Route path={Routes.ACCOUNT_BILLING} component={Billing} />}

				{hasFeature('USERS') && <Route path={Routes.ACCOUNT_USERS} component={Users} />}

				{hasFeature('PAYMENT_SETTINGS') && (
					<Route path={Routes.ACCOUNT_PAYMENTS} component={Payments} />
				)}

				{hasFeature('INTEGRATIONS') && (
					<Route path={Routes.ACCOUNT_INTEGRATIONS} component={Integrations} />
				)}

				{hasFeature('REPORTS') && <Route path={Routes.ACCOUNT_ACCOUNTING} component={Accounting} />}

				<Route path={Routes.ACCOUNT_MARKETING} component={Marketing} />

				{hasFeature('REPORTS') && <Route path={Routes.ACCOUNT_REPORTS} component={Reports} />}

				{hasFeature('LANGUAGES', { scope: 'user' }) && (
					<Route path={Routes.ACCOUNT_LANGUAGES} component={Languages} />
				)}

				{hasFeature('NOTIFICATIONS') && (
					<Route path={Routes.ACCOUNT_NOTIFICATIONS} component={Notifications} />
				)}

				{hasFeature('TAXES') && <Route path={Routes.ACCOUNT_TAXES} component={Taxation} />}

				{hasFeature('LOCALIZATION') && (
					<Route path={Routes.ACCOUNT_LOCALIZATION} component={Localization} />
				)}

				{hasFeature('DOMAINS') && <Route path={Routes.ACCOUNT_DOMAINS} component={Domains} />}

				<Redirect to={Routes.ACCOUNT} />
			</Switch>
		</>
	);
};

export default Account;
